/**
 * The two ids that tie a group's place on the accessory rail to the panel it
 * opens.
 *
 * Spelled out rather than left to the primitive, which mints them when a panel
 * REGISTERS itself — on mount, so a server-rendered rail would announce no
 * relationship at all until React caught up. Both halves derive them from the
 * taxon code, so each pair is the same string on the server and in the browser.
 *
 * Their own module because both the rail and the panel need them, and neither
 * of those two components owns the other.
 */
export const accessoriesTabId = (taxonCode: string): string => `accessories-tab-${taxonCode}`;

export const accessoriesPanelId = (taxonCode: string): string => `accessories-panel-${taxonCode}`;
